<template>
    <v-card flat v-if="buyOption && buyOption.Values">
        <v-card-title primary-title>
            <div class="body-2">{{buyOption.description}}</div>
        </v-card-title>

        <v-card-text>
            <v-layout v-for="option in buyOption.Values" :key="option.value" align-center class="pt-1">
                <v-flex sm9 xs6>
                    <div class="body-2">{{option.name | translation}}</div>
                    <div class="caption" v-html="option.description"></div>
                </v-flex>

                <v-spacer></v-spacer>

                <v-text-field
                    class="pa-0 ma-0"
                    v-model="models[option.value]"
                    style="width: 100px"
                    append-outer-icon="add"
                    @click:append-outer="increaseOptionAmount(option)"
                    prepend-icon="remove"
                    @click:prepend="decreaseOptionAmount(option)"
                    @change="changeOptionAmount(option)"
                    :ref="option.value + '-textfield'"
                    @keyup.enter="$refs[option.value + '-textfield'][0].blur()"
                    hide-details
                ></v-text-field>
            </v-layout>

            <v-layout class="pt-2">
                <v-flex xs6>
                    <div class="body-2">{{'Currently in your box' | translation}}</div>
                </v-flex>

                <v-flex xs6 text-xs-right>
                    <div class="body-2">{{displayTotal}}</div>
                </v-flex>
            </v-layout>

            <v-layout class="pt-1">
                <v-flex xs6>
                    <div class="body-2">{{'Max' | translation}}</div>
                </v-flex>

                <v-flex xs6 text-xs-right>
                    <div class="body-2">{{maxValue}}</div>
                </v-flex>
            </v-layout>
        </v-card-text>
    </v-card>
</template>

<script>
    import Vue from 'vue';

    const moduleName = 'package-config-buy-option';

    export default {
        name: moduleName,
        props: [
            'buyOption',
        ],
        data() {
            return {
                models: {},
                displayTotal: 0,
            };
        },
        computed: {
            currentTotal() {
                let total = 0;

                for (let model of Object.values(this.models)) {
                    total += parseInt(model);
                }

                return total;
            },
            maxValue() {
                return parseInt(this.buyOption.value);
            },
        },
        methods: {
            increaseOptionAmount(option) {
                this.models[option.value]++;
                this.changeOptionAmount(option);
            },
            decreaseOptionAmount(option) {
                if (this.models[option.value] > 0) {
                    this.models[option.value]--;
                    this.changeOptionAmount(option);
                }
            },
            changeOptionAmount(option) {
                this.models[option.value] = Math.abs(this.models[option.value]);

                if (this.currentTotal > this.maxValue) {
                    this.models[option.value] = parseInt(this.models[option.value]) -
                        (parseInt(this.currentTotal) - parseInt(this.maxValue));
                }

                this.displayTotal = this.currentTotal;

                if (this.displayTotal === this.maxValue) {
                    let result = {};
                    for (let value of this.buyOption.Values) {
                        result[value.value] = {
                            ...value,
                            value: this.models[value.value],
                        };
                    }
                    this.$emit('input', result);
                } else {
                    this.$emit('input', {});
                }
            },
        },
        watch: {
            buyOption: {
                handler(buyOption) {
                    let models = {};

                    if (buyOption && buyOption.Values) {
                        for (let option of buyOption.Values) {
                            models[option.value] = 0;
                        }
                    }

                    this.models = Vue.observable(models);
                },
                immediate: true,
            },
        },
    };
</script>